import React from 'react';
import styled from 'styled-components';

export function Loader() {
  return (
    <div className="lds-roller" data-testid="loader">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}

export function PageLoader() {
  return (
    <PageLoaderWrapper data-testid="pageloader">
      <Loader />
    </PageLoaderWrapper>
  );
}

const PageLoaderWrapper = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
`;
